import React, { createContext, useContext, useState, useCallback, useMemo } from 'react';

const SettingsSheetContext = createContext(null);

/**
 * Single global settings-sheet open/section state so any component — the
 * Header gear, the mobile settings tab, and (from Task 6) episode rows that
 * link straight to "downloads" — can open the sheet, optionally scrolled to
 * a named section, without prop-drilling through Header.
 */
export function SettingsSheetProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);
  const [section, setSection] = useState(null);

  const open = useCallback((nextSection = null) => {
    setSection(nextSection);
    setIsOpen(true);
  }, []);

  const close = useCallback(() => {
    setIsOpen(false);
  }, []);

  const value = useMemo(
    () => ({ isOpen, section, open, close }),
    [isOpen, section, open, close]
  );

  return (
    <SettingsSheetContext.Provider value={value}>
      {children}
    </SettingsSheetContext.Provider>
  );
}

export function useSettingsSheet() {
  const ctx = useContext(SettingsSheetContext);
  if (!ctx) throw new Error('useSettingsSheet must be used within SettingsSheetProvider');
  return ctx;
}
